import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { catchError, map, concatMap, switchMap, filter, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as AuthActions from './auth.actions';
import * as RouterActions from '@app/core/store/router/router.actions';
import { AuthenticationService } from '@app/core/services';
import { AuthorizationResponse } from '@app/account/models/authorization-response.model';
import { TokenStorageService } from '@app/core/services/token-storage.service';
import { Router } from '@angular/router';
import { ToastService } from '@app/core/services/toast.service';
import { Action, Store } from '@ngrx/store';
import { AppState } from '../app.state';

@Injectable()
export class AuthEffects implements OnInitEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private authenticationService: AuthenticationService,
    private tokenStorageService: TokenStorageService,
    private router: Router,
    private toastService: ToastService,
  ) { }

  ngrxOnInitEffects(): Action {
    // const token = this.tokenStorageService.getToken();
    // if(token) {
    //   const user = this.tokenStorageService.getEffectiveUser();
    //   // eslint-disable-next-line object-shorthand
    //   return AuthActions.UpdateUserAuthDetails({isAuthenticated: true, user: user});
    // } else {
    //   return AuthActions.UpdateUserAuthDetails({isAuthenticated: false, user: null});
    // }
    return AuthActions.UpdateUserAuthDetails({isAuthenticated: false, user: null});
}

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.LoginRequested),
      switchMap((action) =>
        this.authenticationService.login$(action.authCredentials).pipe(
          map((response: AuthorizationResponse) =>
            response.succeeded
              ? AuthActions.LoginSuccess({ response })
              : AuthActions.LoginFailure({
                  error: Error(response.errorMessage)
                })
          ),
          catchError((error: any) => of(AuthActions.LoginFailure({ error })))
        )
      )
    )
  );

  loginSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.LoginSuccess),
        tap((action) => {
          this.tokenStorageService.saveUser(action.response.user);
        }),
        map(RouterActions.NavigateToUsers)
      ));

  authFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.LoginFailure, AuthActions.ResetPasswordFailure),
        tap((action) => {
          this.toastService.showErrorToast(action.error);
        })
      ),
    {
      dispatch: false
    }
  );

  logout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.LogoutRequested),
        tap(() => {
          this.tokenStorageService.clearStorage();
          this.router.navigate(['/account/login']);
        }),
        map((action) => AuthActions.LogoutSuccess())
      )
  );
}
